/**
 * DG Newmedia Settings
 */

const settings = {
  // vertical offset in px before element is first unpinned
  offset: 150,
  // scroll tolerance in px before state changes
  // tolerance: 0,
  // or you can specify tolerance individually for up/down scroll
  // tolerance: {
  // up: 0,
  // down: 0,
  // },
  // css classes to apply
  classes: {
  // when element is initialised
    initial: 'c-header--init',
    // when scrolling up
    pinned: 'c-header--is-pinned',
    // when scrolling down
    unpinned: 'c-header--is-unpinned',
    // when above offset
    top: 'c-header--is-top',
    // when below offset
    notTop: 'c-header--is-not-top',
    // when at bottom of scoll area
    bottom: 'c-header--is-bottom',
    // when not at bottom of scroll area
    notBottom: 'c-header--not-bottom',
    // when frozen method has been called
    frozen: 'c-header--is-frozen',
  },
  // element to listen to scroll events on, defaults to `window`
  // scroller: someElement,
  // callback when pinned, `this` is headroom object
  // onPin () {},
  // callback when unpinned, `this` is headroom object
  // onUnpin () {},
  // callback when above offset, `this` is headroom object
  // onTop () {},
  // callback when below offset, `this` is headroom object
  // onNotTop () {},
  // callback when at bottom of page, `this` is headroom object
  // onBottom () {},
  // callback when moving away from bottom of page, `this` is headroom object
  // onNotBottom () {},
};

export default settings;



// WEBPACK FOOTER //
// ./src/scripts/settings-headroom.js